function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React from 'react';
import { Box, Button, Card, CardBody, Image, Text, Video } from 'grommet';
import { Close, Upload, Validate } from 'grommet-icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
`;
const DropZone = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #eeeeee;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  &:focus {
    border-color: #2196f3;
    box-shadow: none;
  }
`;
const CropContainer = styled(Box)`
  position: relative;
  height: 283px;
  width: 100%;
  position: relative;
  background: #333;
  pointer-events: ${props => props.disabled === true ? 'none' : 'initial'};
`;
const UploadingBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
`;
const getCroppedImg = (image, crop, filename, callback) => {
  const canvas = document.createElement('canvas');
  const scaleX = crop.imageNaturalWidth / crop.imageWidth;
  const scaleY = crop.imageNaturalHeight / crop.imageHeight;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
  const reader = new FileReader();
  canvas.toBlob(blob => {
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      callback(dataURLtoFile(reader.result, filename));
    };
  });
};
const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let croppedImage = new File([u8arr], filename, {
    type: mime
  });
  // console.log(croppedImage);
  return croppedImage;
};

// Convert bytes into next nearest unit
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
const UploadZone = ({
  getRootProps,
  getInputProps,
  className
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    direction: "row-responsive",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DropZone, _extends({
    height: "large"
  }, getRootProps({
    className: 'dropzone'
  })), /*#__PURE__*/React.createElement(Upload, {
    color: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("input", _extends({
    accept: ".pdf"
  }, getInputProps())), /*#__PURE__*/React.createElement("p", null, "Drag 'n' drop some files here, or click to select files"))));
};
const LayerHeader = ({
  setLayer,
  title
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    flex: {
      shrink: 0
    },
    justify: "between",
    direction: "row",
    pad: {
      top: 'medium',
      left: 'medium',
      right: 'medium',
      bottom: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "15px"
  }, title), /*#__PURE__*/React.createElement(Box, {
    pad: {
      top: 'xsmall'
    },
    onClick: () => setLayer(false)
  }, /*#__PURE__*/React.createElement(Close, {
    size: "20px"
  })));
};
const LayerFooter = ({
  setLayer,
  errors,
  files,
  isSubmitting
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    as: "footer",
    gap: "small",
    direction: "row",
    align: "center",
    justify: "end",
    pad: {
      top: 'medium',
      bottom: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    color: "status-critical"
  }, errors.non_field), /*#__PURE__*/React.createElement(Button, {
    onClick: () => setLayer(false),
    alignSelf: "end",
    margin: {
      vertical: 'small'
    },
    label: "Close",
    primary: true
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    alignSelf: "end",
    margin: {
      vertical: 'small'
    },
    label: isSubmitting === true ? 'Please Wait...' : 'Upload',
    primary: true,
    disabled: files.length < 1 || isSubmitting === true
  }));
};
const FileSelectedPreview = () => {
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row-responsive",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DropZone, {
    height: "large"
  }, /*#__PURE__*/React.createElement(Validate, {
    color: "#1DB954"
  }), /*#__PURE__*/React.createElement("p", null, "File has been selected. Click Upload to proceed."))));
};
const VideoPreview = ({
  file
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row-responsive",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DropZone, {
    height: "medium"
  }, /*#__PURE__*/React.createElement(Video, {
    fit: "contain",
    fill: true,
    autoPlay: true
  }, /*#__PURE__*/React.createElement("source", {
    src: typeof file === 'string' ? file : URL.createObjectURL(file),
    type: file.type
  })))));
};
const ImagePreview = ({
  file
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row-responsive",
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DropZone, {
    height: "medium"
  }, /*#__PURE__*/React.createElement(Image, {
    fallback: "//v2.grommet.io/assets/IMG_4245.jpg",
    src: URL.createObjectURL(file),
    fit: "contain",
    fill: true
  }))));
};
const DocsPreview = ({
  file
}) => {
  const src = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(file);
  return /*#__PURE__*/React.createElement(Box, {
    fill: true,
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement("iframe", {
    title: "document",
    src: src,
    width: "100%",
    height: "100%"
  }));
};
const FileList = ({
  files,
  removeFile,
  setFieldValue,
  className
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    overflow: "auto",
    height: {
      max: '300px'
    }
  }, React.Children.toArray(files.map(file => {
    return /*#__PURE__*/React.createElement(Box, {
      margin: "small",
      height: {
        min: '32px'
      }
    }, /*#__PURE__*/React.createElement(Card, {
      pad: "small",
      gap: "medium",
      background: "light-3"
    }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Box, {
      justify: "between",
      direction: "row"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "10px",
      weight: "bold"
    }, file.name), /*#__PURE__*/React.createElement(Box, {
      onClick: () => removeFile(files, file, setFieldValue),
      focusIndicator: false
    }, /*#__PURE__*/React.createElement(Close, {
      size: "16px"
    }))))));
  })));
};
UploadZone.propTypes = {
  getRootProps: PropTypes.func,
  getInputProps: PropTypes.func,
  className: PropTypes.string
};
LayerHeader.propTypes = {
  setLayer: PropTypes.func,
  title: PropTypes.string
};
LayerFooter.propTypes = {
  setLayer: PropTypes.func,
  errors: PropTypes.object,
  files: PropTypes.array,
  isSubmitting: PropTypes.bool
};
FileList.propTypes = {
  files: PropTypes.array,
  removeFile: PropTypes.func,
  setFieldValue: PropTypes.func,
  className: PropTypes.string
};
ImagePreview.propTypes = {
  file: PropTypes.any
};
VideoPreview.propTypes = {
  file: PropTypes.any
};
DocsPreview.propTypes = {
  file: PropTypes.any
};
export { dataURLtoFile, getCroppedImg, CropContainer, FileList, FileSelectedPreview, ImagePreview, LayerFooter, LayerHeader, UploadingBox, UploadZone, VideoPreview, DocsPreview, formatBytes };